import BaseComponent from './BaseComponent'; 

class SigningButton extends BaseComponent {

    waitingResponse = false;

    constructor(props){
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.newSigningCallback = this.newSigningCallback.bind(this);

        this.state = {};
    }

    handleClick(e){
    	if(!this.waitingResponse){
    		this.waitingResponse = true;
		const api = this.getApi();
		api.newSigningByToken([],this.newSigningCallback);
	}
    }

    newSigningCallback(response){
    	    this.waitingResponse = false;
    	    if(response.status === 'OK'){
		this.setState(prevState => {
			return {
				...prevState,
				signed_on: response.signings.length % 2 !== 0
			}
		});
	    }
	    this.props.config.callback(response);
    }

    renderButton(){
	return  (<button type="button" className={"btn "+(this.state.signed_on && this.state.signed_on === true?"btn-danger":
				this.props.config.signed_on === true?"btn-danger":"btn-success")} 
           	onClick={this.handleClick.bind(this)}>
		{this.state.signed_on && this.state.signed_on === true?"Fichar salida":
		this.props.config.signed_on === true?"Fichar salida":"Fichar entrada"}
           </button>);

    }

    render() {
        return 	this.renderButton()
    }
}

export default SigningButton;
//export default connect(mapStateToProps, mapDispatchToProps)(SigningButton)
